<template>
  <div>
    <v-icon v-if="value" small @click="dialog = !dialog">mdi-qrcode-scan</v-icon>
    <v-snackbar
        v-model="dialog"
        :timeout="timeout"
        vertical
        top
        light
    >
      <qr-code v-if="!!value" :text="value" :size="size"></qr-code>
      <template v-slot:action="{ attrs }">
        <span>{{text}}</span>
        <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="dialog = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>

export default {
  name: 'CommonQR',
  props: {
    value: {type: [String], default: null},
    text: {type: [String], default: null},
    timeout: {type: [Number], default: 10000},
    opened: {type: [Boolean], default: false},
  },

  components: {},

  computed: {},

  methods: {},

  async mounted() {
    this.dialog = this.opened
  },

  data() {
    return {
      dialog: false,
      size: 256 + 96
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
